const PERMISSIONS = [
  {
    subordinates: [
      {
        title: "数据看板",
        subordinates: [{ actionName: "查看", key: "create-dashboard-view" }],
      },
      {
        title: "文章发布",
        subordinates: [
          { actionName: "查看", key: "create-article-view" },
          { actionName: "添加", key: "create-article-create" },
          { actionName: "编辑信息", key: "create-article-update-info" },
          { actionName: "编辑详情", key: "create-article-update-detail" },
          { actionName: "评论", key: "create-article-comment" },
          { actionName: "显示/隐藏", key: "create-article-showstate" },
          { actionName: "撤稿", key: "create-article-cancel" },
          // { actionName: "免审发布", key: "create-article-publish" },
          {
            actionName: "提交审核/撤销审核/驳回原因",
            key: "create-article-review",
          },
          { actionName: "移除", key: "create-article-delete" },
        ],
      },
      {
        title: "视频发布",
        subordinates: [
          { actionName: "查看", key: "create-video-view" },
          { actionName: "添加", key: "create-video-create" },
          { actionName: "编辑信息", key: "create-video-update-info" },
          { actionName: "编辑详情", key: "create-video-update-detail" },
          { actionName: "评论", key: "create-video-comment" },
          { actionName: "显示/隐藏", key: "create-video-showstate" },
          { actionName: "撤稿", key: "create-video-cancel" },
          // { actionName: "免审发布", key: "create-video-publish" },
          {
            actionName: "提交审核/撤销审核/驳回原因",
            key: "create-video-review",
          },
          { actionName: "移除", key: "create-video-delete" },
        ],
      },
      {
        title: "话题-列表",
        subordinates: [
          { actionName: "查看", key: "topic-view" },
          { actionName: "添加", key: "topic-create" },
          { actionName: "编辑", key: "topic-update" },
          { actionName: "移除", key: "topic-delete" },
          { actionName: "内容管理", key: "topic-comment" },
          { actionName: "显示/隐藏", key: "topic-state" },
        ],
      },
      {
        title: "话题-内容管理",
        subordinates: [
          { actionName: "查看", key: "topicContent-view" },
          { actionName: "编辑", key: "topicContent-update" },
          { actionName: "回复", key: "topicContent-reply" },
          { actionName: "置顶/取消置顶", key: "topicContent-top" },
        ],
      },
      {
        title: "话题-回复",
        subordinates: [
          { actionName: "查看", key: "topicReply-view" },
          { actionName: "添加", key: "topicReply-create" },
          { actionName: "编辑", key: "topicReply-update" },
          { actionName: "移除", key: "topicReply-delete" },
          { actionName: "入库", key: "topicReply-storage" },
        ],
      },
      {
        title: "问卷管理",
        subordinates: [
          { actionName: "查看", key: "question-qa-view" },
          { actionName: "添加", key: "question-qa-create" },
          { actionName: "编辑", key: "question-qa-update" },
          { actionName: "显示/隐藏", key: "question-qa-state" },
          { actionName: "成绩数据", key: "question-qa-score" },
          { actionName: "移除", key: "question-qa-delete" },
        ],
      },
      {
        title: "题库管理",
        subordinates: [
          { actionName: "查看", key: "question-bank-view" },
          { actionName: "添加", key: "question-bank-create" },
          { actionName: "编辑", key: "question-bank-update" },
          { actionName: "显示/隐藏", key: "question-bank-state" },
          { actionName: "移除", key: "question-bank-delete" },
        ],
      },
      // {
      //   title: "分值管理",
      //   subordinates: [
      //     { actionName: "查看", key: "question-score-view" },
      //     { actionName: "编辑", key: "question-score-update" },
      //   ],
      // },
      {
        title: "媒体号管理",
        subordinates: [
          { actionName: "查看", key: "create-media-view" },
          { actionName: "编辑", key: "create-media-update" },
        ],
      },
      {
        title: "运营活动管理",
        subordinates: [{ actionName: "查看", key: "create-cdp-view" }],
      },
      {
        title: "媒体资源库管理",
        subordinates: [
          { actionName: "查看", key: "create-mediaLibrary-view" },
          { actionName: "添加", key: "create-mediaLibrary-add" },
        ],
      },
      {
        title: "圈子管理",
        subordinates: [
          { actionName: "查看", key: "create-circle-view" },
          { actionName: "添加", key: "create-circle-create" },
          { actionName: "编辑", key: "create-circle-update" },
          { actionName: "移除", key: "create-circle-delete" },
          { actionName: "显示/隐藏", key: "create-circle-state" },
          { actionName: "内容管理", key: "create-circle-content" },
        ],
      },
      {
        title: "角色管理",
        subordinates: [
          { actionName: "查看", key: "create-role-view" },
          { actionName: "添加", key: "create-role-create" },
          { actionName: "编辑", key: "create-role-update" },
          { actionName: "移除", key: "create-role-delete" },
        ],
      },
      {
        title: "运营人员管理",
        subordinates: [
          { actionName: "查看", key: "create-operator-view" },
          { actionName: "添加", key: "create-operator-create" },
          { actionName: "编辑", key: "create-operator-update" },
          { actionName: "移除", key: "create-operator-delete" },
          { actionName: "启用/禁用", key: "create-operator-state" },
        ],
      },
      {
        title: "圈子评论管理",
        subordinates: [
          { actionName: "查看", key: "create-circleComment-view" },
          { actionName: "添加", key: "create-circleComment-create" },
          { actionName: "编辑", key: "create-circleComment-update" },
          { actionName: "移除", key: "create-circleComment-delete" },
        ],
      },
      {
        title: "用户中心",
        subordinates: [
          { actionName: "查看", key: "create-user-view" },
          // { actionName: "添加", key: "create-user-create" },
          { actionName: "编辑", key: "create-user-update" },
        ],
      },
    ],
  },
];

export { PERMISSIONS };
